<div class="panel-wrapper">
    <div class="panel-header">
        <div class="panelHead">
            <span class="panel-header-text">{{booking?.spotBookingType}}</span>
            <span mis-input-icon (click)="close()" class="close-btn"><img src="/assets/images/cancel_24.svg"
                    alt="" /></span>
        </div>
                <div class="booking-id-wrapper">
                    <span class="booking-id  master-id" *ngIf="booking?.masterBookingId">Master ID: {{booking.masterBookingId}}</span>
                    <span class=" booking-id">{{booking.bookingId}}</span>
                </div>
    </div>
    <div class="panel-body">
        <div class="booking-status">
            <span class="booking-date">{{transformDate(booking?.startTime.split(' ')[0])}}</span>
            <span
                [ngClass]="{'booking-status-cancelled': booking.bookingStatus === 'CANCELLED', 'booking-status-active': booking.bookingStatus === 'ACTIVE'}"
                *ngIf="booking.paymentStatus !== 'PROCESSING'">{{bookingFinalStatus}}</span>
        </div>
        <div class="additional-info-box">
                <div class="info-box">
                    <span class="label">Vehicle Report Time</span>
                    <span class="info">{{booking.cabArrivalTime!==""?(booking.cabArrivalTime |twelvehourtimeformatter):'--:--'}}</span>
                </div>
                <div class="line"></div>
                <div class="info-box">
                    <span class="label">Trip Start</span>
                    <span class="info">{{booking.tripStartTime!==""?(booking.tripStartTime |twelvehourtimeformatter):'--:--'}}</span>
                </div>
                <div class="line"></div>
                <div class="info-box">
                    <span class="label">Trip End</span>
                    <span class="info">{{booking.tripEndTime!==""?(booking.tripEndTime | twelvehourtimeformatter):'--:--'}}</span>
                </div>
        </div>

        <!-- ----------------multiday-routes -->
        <div class="multiTrip-content mt-24" *ngIf="booking.multiDayBooking; else onewayTrip">
            <div class="days displayFlexColumn" *ngFor="let day of multidayTrips; let dayIndex=index">
                <div class="dayStops " *ngFor="let stop of day.stops; let stopIndex=index">
                    <div 
                    [ngClass]="stopIndex==0 ? 'pb-24':''" >
                        <div *ngIf="stopIndex==0" class="dayCount ">Day-{{day.day}}</div>
                    </div>
                 <div class="each-stop displayFlex fs-14"
                        [ngClass]="(stopIndex==day.stops.length-1 && dayIndex==multidayTrips.length-1 )  ? 'last-day-stop'  : (stopIndex==day.stops.length-1) ? 'last-stop':'each-stop'">
                    <span><img class="icon-small" [src]="(dayIndex==multidayTrips.length-1) ? (stopIndex==day.stops.length-1 ? 'assets/ic-location2.svg' : 'assets/ic-ui-location1.svg' ):  'assets/ic-ui-location1.svg'" alt=""></span>
                    <div class="displayFlexColumn address-section">
                        <div *ngIf="dayIndex==0 && stopIndex==0" class="boxedContent">{{startTime | twelvehourtimeformatter}}</div>
                        <div>{{stop.address}}</div> 
                        <div class="fs-12 geoaraea-label mt-8">{{stop.geoArea}}</div>
                    </div>
                </div> 
                </div>
            </div>
        </div>


        <ng-template #onewayTrip>
            <div *ngIf="stopsDetails.length>0" class="trip-content displayFlexColumn">
                <ng-container *ngFor="let stop of stopsDetails; let i=index;">
                    <div [ngClass]=" stop.pointType == 'END' ? 'endRoute' : 'route' ">
                        <span class="stopImages">
                            <img
                                [src]=" stop.pointType == 'START' ? 'assets/ic-ui-location1.svg' : stop.pointType == 'END' ? 'assets/ic-location2.svg' : 'assets/ic-ui-seperator.svg'"
                                alt="stopTypeImg">
                        </span>
                        <div [ngClass]="stop.pointType == 'END'? 'endRouteData' : 'routeData' ">
                            <span *ngIf="stopsDetails[i]['time'] && stopsDetails[i]['time'] != ''" class="boxedContent">
                                {{stopsDetails[i]['time'] | twelvehourtimeformatter}} </span>
                            <span class="routeAddress fs-12">{{stopsDetails[i]['address']}}</span>
                            <span class="landmark" *ngIf="stopsDetails[i]['geoArea']"> {{stopsDetails[i]['geoArea'] | titlecase}} </span>
                            <span *ngFor="let rider of stop.riders" class="riderData">
                                <span class="boardingIcon">
                                    <img
                                        [src]=" rider.boardingType == 'PickUp' ? 'assets/ic-mobile-top arrow on-24.png' : 'assets/ic-mobile-top arrow on-24.svg' "
                                        alt="boardingTypeImg">
                                </span>
                                <span [ngClass]=" rider.boardingType == 'PickUp' ? 'pickup' : 'dropoff'"
                                   >{{rider.boardingType == 'PickUp' ? 'Pickup' : 'Dropoff'}}</span>
                                <span class="riderName fs-12">{{rider.name | titlecase}}</span>
                            </span>
                        </div>
                    </div>
                </ng-container>
            </div>
        </ng-template>
         <!-- ------------Recoverable Type------- -->
         <div *ngIf="miscelleneousConfig?.verifyEngagementCode" class="requester-content mb-12">
            <div class="cab-content-wrapper">
                <div class="displayFlexColumn">
                    <div class="fs-12 font-weight-400 label-color-929DAB mb-2">Recoverable Type</div>
                    <div class="fs-14 font-weight-400 color-181F33">{{booking?.billableType || '--'}}</div>
                    <ng-container *ngIf="booking?.manager">
                        <div class="fs-12 font-weight-400 label-color-929DAB mb-2 mt-16">Reporting Manager</div>
                        <div class="fs-14 font-weight-400 color-181F33">{{booking.manager.name || '--'}} ({{booking.manager.id || '--'}})</div>
                    </ng-container>
                    <ng-container *ngIf="booking?.partner">
                        <div class="fs-12 font-weight-400 label-color-929DAB mb-2 mt-16">Partner</div>
                        <div class="fs-14 font-weight-400 color-181F33">{{booking.partner.name || '--'}} ({{booking.partner.id || '--'}})</div>
                    </ng-container>
                </div>
            </div>
        </div>
         <!-- ------------comments------- -->
         <div *ngIf="booking?.reason || booking?.flightDetails || booking?.travelPurpose || booking?.otherDetails" class="requester-content mb-12">
            <div class="cab-content-wrapper">
                <div class="displayFlexColumn" [ngStyle]="{'gap': '16px'}">
                    <div *ngIf="booking?.travelPurpose">
                        <div class="fs-12 font-weight-400 label-color-929DAB mb-2">{{travelPurposeConfig?.config?.displayName}}</div>
                        <div class="fs-14 font-weight-400 color-181F33">{{booking.travelPurpose}}</div>
                    </div>
                    <div *ngIf="booking?.reason">
                        <div class="fs-12 font-weight-400 label-color-929DAB mb-2">{{reasonConfig?.config?.displayName}}</div>
                        <div class="fs-14 font-weight-400 color-181F33">{{booking.reason}}</div>
                    </div>
                    <div *ngIf="booking?.flightDetails">
                        <div class="fs-12 font-weight-400 label-color-929DAB mb-2">{{flightDetailsConfig?.config?.displayName}}</div>
                        <div class="fs-14 font-weight-400 color-181F33">{{booking.flightDetails}}</div>
                    </div>
                    <div *ngIf="booking?.otherDetails">
                        <div class="fs-12 font-weight-400 label-color-929DAB mb-2">{{otherDetailsConfig?.config?.displayName}}</div>
                        <div class="fs-14 font-weight-400 color-181F33">{{booking.otherDetails}}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- ------------passenger details  -->
        <div class="requester-content">
            <div class="cab-content-wrapper">
                <div class="mb-12">
                    <span class="fs-14 color-000 font-weight-700">Passenger Details</span>
                </div>
                <div class="" *ngFor="let rider of passanger;let i = index">
                    <div [ngClass]="i==passanger.length-1 ? '' : 'mb-24 padding-bottom-16 border-bottom-E0E0E0' "
                        class="displayFlexRow displayFlexSpaceBetween ">
                        <div [ngClass]="showOtpProperty ? 'riderDetails':''">
                            <div class="fs-12 color-000 mb-4 overflow-ellipse"
                                matTooltip="{{ rider.name}} ({{rider.emplId}})" matTooltipClass="booking-table-tooltip">
                                {{ rider?.name || '--'}} ({{rider?.emplId}})</div>
                            <div class=" label-color-929DAB mb-2 fs-14 overflow-ellipse" matTooltip="{{rider.email}}"
                                matTooltipClass="booking-table-tooltip">{{rider?.email || '--'}}</div>
                            <div class="fs-12 displayFlexRow label-color-929DAB flex-wrap ">
                                <span> {{(rider?.mobile | formatPhoneNumber : rider) || '--'}}</span>
                                <span class="ml-12 mr-12 ellipseSeparator"><img src="assets/images/EllipseSeparator.svg"
                                        alt=""></span>
                                <span> {{(rider?.alternateMobile | formatPhoneNumber : rider)||''}}</span>
                                <span  *ngIf="rider?.alternateMobile" class="ml-12 mr-12 ellipseSeparator"><img src="assets/images/EllipseSeparator.svg"
                                    alt=""></span>
                                <span class="overflow-ellipse" matTooltip="{{rider?.costCenter}}"
                                    matTooltipClass="booking-table-tooltip"> {{rider?.costCenter || '--'}}</span>
                            </div>
                            <div class="fs-12 displayFlexRow label-color-929DAB flex-wrap ">
                                <span> {{rider?.department || '--'}}</span>
                            </div>
                        </div>

                        <app-rider-otp-view *ngIf="!rider.noShow && showOtpProperty && rider.otp;else noshow"
                            [otp]="rider.otp" >
                        </app-rider-otp-view>
                        <ng-template #noshow>
                            <div *ngIf="rider.noShow" class="font-weight-700 fs-12 noshow">
                                NO SHOW
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
        <!--- Marshall info -->
        <div *ngIf="booking.guardReq" class="requester-content">
            <div class="cab-content-wrapper">
                <div class="mb-12">
                    <span class="fs-14 color-000 font-weight-700">Marshall Details</span>
                </div>
                <div class="" *ngIf="marshall">
                    <div 
                        class="displayFlexRow displayFlexSpaceBetween ">
                        <div [ngClass]="showOtpProperty ? 'riderDetails':''">
                            <div class="fs-12 color-000 mb-4 overflow-ellipse"
                                matTooltip="{{ marshall.name}} ({{marshall.emplId}})" matTooltipClass="booking-table-tooltip">
                                {{ marshall?.name || '--'}} ({{marshall?.emplId}})</div>
                            <div class=" label-color-929DAB mb-2 overflow-ellipse fs-14" matTooltip="{{marshall.email}}"
                                matTooltipClass="booking-table-tooltip">{{marshall?.email || '--'}}</div>
                            <div class="fs-12 displayFlexRow label-color-929DAB ">
                                <span> {{marshall?.mobile || '--'}}</span>
                            </div>
                        </div>

                        <div *ngIf="showOtpProperty && marshall.otp" class="displayFlexColumn">
                            <div [ngStyle]="marshall.otp.includes(',') ? {'border-bottom': '1px solid #e0e0e0', 'margin-bottom':'8px', 'padding-bottom':'4px'}: {} ">
                                <div class=" displayFlexRow">
                                    <span class="startOtp otpDigits background-10ADAE fs-12"
                                        *ngFor="let otp of marshall.otp.split(',')[0].split('')">
                                        {{otp}}
                                    </span>
                                </div>
                                <div class="otpText mt-4">
                                    START OTP
                                </div>
                            </div>
                            <div *ngIf="marshall.otp.includes(',')">
                                <div class="displayFlexRow">
                                    <span class="endOtp otpDigits background-0087B2 fs-12"
                                        *ngFor="let otp of marshall.otp.split(',')[1].split('')">
                                        {{otp}}
                                    </span>
                                </div>
                                <div class="otpText mt-4">
                                    END OTP
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!marshall" class="label-color-929DAB mb-2 ">
                    Details will be available once Marshal is assigned.
                </div>
            </div>
        </div>
        <div class="cab-content">
            <div class="cab-content-wrapper">
                <div class=" displayFlexRow displayFlexSpaceBetween">
                    <div>
                        <div class="fs-12 label-color-929DAB mb-4">Vendor</div>
                        <div class="fs-12 color-000">{{booking?.vendor?.vendorName || '--'}}</div>
                    </div>
                    <!-- <div class="track">
                        <button mis-button class="btn-track" (click)="OpenTrack()">
                            <span mis-input-icon class="mt-4"><img src="/assets/images/track.svg" alt="" /></span>
                            <span>Track</span>
                        </button>
                    </div> -->
                </div>
                <div class="mt-16 displayFlexColumn ">
                    <div class="fs-12 label-color-929DAB mb-4">Cab Details</div>
                    <div class="fs-12 displayFlexRow color-000">
                        <span> {{booking?.cab?.registration || '--'}}</span>
                        <span class="ml-12 mr-12 ellipseSeparator"><img src="assets/images/EllipseSeparator.svg"></span>
                        <span>{{booking?.cab?.cabType?.name || '--'}}</span>
                    </div>
                </div>
                <div class="mt-16 displayFlexColumn ">
                    <div class="fs-12 label-color-929DAB mb-4">Driver Details</div>
                    <div class="fs-12 displayFlexRow color-000">
                        <span> {{booking?.cab?.driver?.name || '--'}}</span>
                        <span class="ml-12 mr-12 ellipseSeparator"><img src="assets/images/EllipseSeparator.svg"></span>
                        <span>{{booking?.cab?.driver?.phoneNumbers[0] || '--'}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="requester-content mb-12">
            <div class="cab-content-wrapper">
                <div class="displayFlexColumn">
                    <div class="mb-12">
                        <span class="fs-14 color-000 font-weight-700">Requester Details</span>
                    </div>
                    <div class="">
                        <div class="fs-12 color-000 mb-4">{{ booking?.requester?.name || '--'}}
                            ({{booking?.requester?.emplId}})</div>
                        <div class=" label-color-929DAB mb-2 fs-12">{{booking?.requester?.email || '--'}}</div>
                        <div class="fs-12 displayFlexRow label-color-929DAB">
                            <span> {{booking?.requester?.mobile || '--'}}</span>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- -----------docs -->

        <div *ngIf="documentList.length>0" class="mt-20">
            <div class="mb-12 font-weight-400 fs-14 color-000">Uploaded Documents</div>
            <div class="displayFlexColumn mb-16">
                <div class="mb-16" *ngFor="let image of documentList; let i = index">
                    <div class="doc-items displayFlexSpaceBetween"
                        (click)="myBookingService.downloadDocument(image.filename,booking.bookingId)">
                        <div class="displayContents">
                            <div class=" displayContents">
                                <img src="assets/upload_document.svg" alt="">
                            </div>

                            <div class="file-details">
                                <span matTooltip="{{image.filename}}" matTooltipClass="doc-upload-tooltip"
                                    class="">{{image.filename}}</span>
                                <span class="">{{myBookingService.convertToMB(image.filesize)}} MB</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- -----------docs -->
    </div>
    <!-- <div class="panel-footer">
        <button mis-button type="primary" size="sm" class="edit" (click)="edit()">Edit</button>
         <mis-dropdown class="menu-dropdown" [data]="dropdownData" [searchEnabled]="false" (onChange)="changeOption($event)" ></mis-dropdown>
    </div> -->
</div>